import React from "react";
import AuthLayout from "../Components/AuthPageLayout";
import SignInForm from "../Components/SignInForm";

function SignIn() {
  return (
    <>
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}


export default SignIn